module.exports = __webpack_public_path__ + "img/small-2.30a8bd79.jpg";